module.exports = __webpack_public_path__ + "img/CENPAY.25cbe31.png";